import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// During preview / local dev without env vars, create a stub so the bundle
// still loads — calls will fail gracefully and produce a clear UI message.
const isConfigured = Boolean(url && anonKey);

export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
        storageKey: "tdt-auth",
      },
    })
  : null;

export const supabaseReady = isConfigured;

export function formatSupabaseError(err) {
  if (!err) return "Something went wrong.";
  if (typeof err === "string") return err;
  if (err.message) return err.message;
  return JSON.stringify(err);
}

/** Throws if Supabase isn't configured — used by data hooks at call time. */
export function requireClient() {
  if (!supabase) {
    throw new Error(
      "Supabase is not configured. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY."
    );
  }
  return supabase;
}
